import { render, staticRenderFns } from "./createCategoryForm.vue?vue&type=template&id=4156bbda&scoped=true"
import script from "./createCategoryForm.vue?vue&type=script&lang=js"
export * from "./createCategoryForm.vue?vue&type=script&lang=js"
import style0 from "./createCategoryForm.vue?vue&type=style&index=0&id=4156bbda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4156bbda",
  null
  
)

export default component.exports